import type { ReactNode } from 'react';
import { BekebiMark } from './brand';

/** The centred card used by the signed-out pages (set password, forgot password). */
export function AuthCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <main className="relative flex min-h-screen flex-col overflow-hidden bg-canvas">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 top-0 h-[28rem] bg-[radial-gradient(ellipse_55%_50%_at_50%_0%,rgb(206_77_31/0.2),rgb(230_158_50/0.06)_55%,transparent)]"
      />
      <div className="relative flex flex-1 items-start justify-center px-4 pb-16 pt-10 sm:items-center sm:pt-0">
        <div className="w-full max-w-[26rem] rounded-2xl border border-line bg-surface px-6 py-8 shadow-2xl shadow-black/40 sm:px-9 sm:py-10">
          <div className="flex justify-center">
            <BekebiMark size={64} />
          </div>
          <h1 className="mt-4 text-center">{title}</h1>
          {children}
        </div>
      </div>
    </main>
  );
}

export const authLinkClass =
  'font-medium text-accent-link underline decoration-accent-link/40 underline-offset-4 hover:decoration-accent-link';
